import React from 'react';
import styles from '../styles/interactive-docs.module.css';

const DocsSidebar = ({
    categories = [],
    activeItemId,
    onSelectItem,
    enabledModules = {},
    isOpen = false,
    onClose
}) => {
    // Фильтрация статей на основе доступных модулей
    const isItemVisible = (item) => {
        if (!item.requiredModule) return true;
        return Boolean(enabledModules[item.requiredModule]);
    };

    const handleItemClick = (id) => {
        onSelectItem(id);
        if (onClose) {
            onClose();
        }
    };

    return (
        <>
            {/* Затемняющий оверлей на мобильных при открытом меню */}
            {isOpen && (
                <div
                    className={styles.sidebarBackdrop}
                    onClick={onClose}
                    aria-hidden="true"
                />
            )}

            <aside className={`${styles.sidebar} ${isOpen ? styles.sidebarOpen : ''}`}>
                {categories.map((category) => {
                    const visibleItems = (category.items || []).filter(isItemVisible);
                    if (visibleItems.length === 0) return null;

                    return (
                        <div key={category.id} className={styles.categoryBlock}>
                            <div className={styles.categoryTitle}>{category.title}</div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                                {visibleItems.map((item) => {
                                    const IconComponent = item.icon;
                                    const isActive = item.id === activeItemId;

                                    return (
                                        <button
                                            key={item.id}
                                            className={`${styles.navItem} ${isActive ? styles.navItemActive : ''}`}
                                            onClick={() => handleItemClick(item.id)}
                                            title={item.title}
                                        >
                                            <span className={styles.navItemLabel}>
                                                {IconComponent && <IconComponent size={15} />}
                                                <span>{item.navTitle || item.title}</span>
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </aside>
        </>
    );
};

export default DocsSidebar;
